import Service from '@ember/service';

import ENV from 'rise-ui/config/environment.js';
import { ajax } from 'rise-ui/utils/ajax-rise.js';

const groupBlacklist = [ 'stateId' ];

/**
 * Queries/serializes catalog-record-filter for catalog routes
 * @name CatalogFiltersModelService
 */
export default class CatalogFiltersModelService extends Service {
  async fetch(queryParams, headers = {}) {
    let request;
    const API = ENV.APP.API.DATA;
    const url = [ API.URL , API.NAMESPACE , 'catalog-record-filter' ];
    const args = [ url, { headers, queryParams } ];
    try {
      request = await ajax.get(...args);
    } catch (e) {
      console.log('Request:', ajax.buildUrl(...args));
      throw e;
    }
    return this.serializeMany(request);
  }

  serializeMany(response) {
    const result = [];
    if (response && response.data && response.data.length) {
      response.data.forEach(model => {
        result.push(this.serialize(model));
      });
    }
    return result;
  }

  serialize(model) {
    const attr = model.attributes || {};
    return {
      id:      model.id,
      array:   attr.array,
      key:     attr.key,
      label:   attr.label,
      options: attr.options?.map(v => {
        v.value = String(v.value);
        return v;
      }),
      group:   !groupBlacklist.includes(attr.key),
    };
  }
}
